import { createContext, useContext } from 'react';

import { ISelectOption } from '~/src/dash/components/dropdowns/common';

interface ITargetingSummaryTableContext {
  lists: Record<string, ISelectOption[]>;
}

export const TargetingSummaryTableContext = createContext({} as ITargetingSummaryTableContext);
export const useTargetingSummaryTableStore = (): ITargetingSummaryTableContext =>
  useContext(TargetingSummaryTableContext);
